import { logWrapper } from '../utils';

function customTagsInputDirectiveFactory(runtimeConstant, $timeout) {
  function link(scope, element, attrs, ctrl) {

    let model = ctrl.$viewValue;
    let prev = [];

    if (!angular.isArray(model)) {
      model = [];
    }

    const select = element.find('select');

    $timeout(() => {
      if (!window.jQuery || !window.jQuery.fn.tagsinput) {
        return;
      }

      select.tagsinput();

      const bootstrapTagsInput = element.parent().find('.bootstrap-tagsinput');
      bootstrapTagsInput.addClass('form-control');

      toggleDisabledState(scope.disabled);

      model.forEach(item => select.tagsinput('add', item));

      select.on('itemAdded', handleItemAdded);
      select.on('itemRemoved', handleItemRemoved);
    }, 1000);

    scope.$watch('disabled', () => toggleDisabledState(scope.disabled));

    function handleItemAdded(event) {
      const update = angular.isArray(ctrl.$viewValue) ? ctrl.$viewValue.slice() : [];

      if (update.indexOf(event.item) === -1) {
        update.push(event.item);
      }

      ctrl.$setViewValue(update);
      prev = update.slice();
    }

    function handleItemRemoved(event) {
      let update = angular.isArray(ctrl.$viewValue) ? ctrl.$viewValue.slice() : [];
      const idx = update.indexOf(event.item);

      if (idx !== -1) {
        update.splice(idx, 1);
      }

      ctrl.$setViewValue(update);
      prev = update.slice();
    }

    function toggleDisabledState(isDisabled) {
      const bootstrapTagsInput = element.parent().find('.bootstrap-tagsinput');
      const input = bootstrapTagsInput.find('input');

      if (isDisabled) {
        input.attr('disabled', 'disabled');
        bootstrapTagsInput.attr('disabled', 'disabled');
      } else {
        input.removeAttr('disabled');
        bootstrapTagsInput.removeAttr('disabled');
      }
    }

    ctrl.$render = function () {
      let update = ctrl.$viewValue;
      if (!angular.isArray(update)) {
        update = [];
      }

      const added = update.filter(item => prev.indexOf(item) === -1);
      const removed = prev.filter(item => update.indexOf(item) === -1);

      prev = update.slice();

      removed.forEach(item => select.tagsinput('remove', item));
      select.tagsinput('refresh');
      added.forEach(item => select.tagsinput('add', item));
    };
  }

  function run() {
    try {
      return {
        restrict: 'EA',
        scope: {
          disabled: '=ngDisabled',
        },
        require: 'ngModel',
        template: '<select ng-disabled="disabled" multiple></select>',
        link: link,
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const customTagsInputDirective = ['runtimeConstant', '$timeout', customTagsInputDirectiveFactory];